import React from 'react';
import TextInput from '../../form/TextInput';
import Select from '../../form/Select';
import createForm from "./Form";
import DateTimeInput from "../../form/DateTimeInput";
import {CurrencyFormatter, ProductColumn, UnitFormatter} from "../../../utils/formatters";
import SelectorGrid from "../../form/SelectorGrid/SelectorGrid";

const sortable = true;
const filterable = true;

class RoyaltyReportForm extends React.Component {

    render() {
        return (
            <form onSubmit={this.props.handleSubmit}>
                <div className="row form-row">
                    <div className="col-sm-4 col-sm-push-8">
                        <TextInput
                            name={this.props.componentConfig.idfield}
                            value={this.props.values[this.props.componentConfig.idfield]}
                            label="Kód"
                            role="idfield"
                            {...this.props.getFieldProps(this.props.componentConfig.idfield)}
                        />
                    </div>
                    <div className="col-sm-8 col-sm-pull-4">
                        <Select
                            objectValue={true}
                            name="licensor"
                            component="RoyaltyLicensor"
                            labelKey="name"
                            valueKey="partner_id"
                            storeType="remote"
                            value={this.props.values.licensor}
                            saveChanges={this.props.setFieldValue}
                            label="Partner"
                            {...this.props.getFieldProps("licensor")}/>
                    </div>
                </div>
                <div className="row form-row">
                    <div className="col-md-12">
                        <DateTimeInput
                            {...this.props.getFieldProps("report_date")}
                            name="report_date"
                            value={this.props.values.report_date}
                            label="Dátum"
                            showTime={false}
                            saveChanges={this.props.setFieldValue}
                        />
                    </div>
                </div>
            </form>
        );
    }
}

export default createForm(RoyaltyReportForm);
